<template>
  <form ref="form" @submit.prevent="handleForm">
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-5 pt-3" style="font-weight: bold">
        <p>{{ form.sensor }}</p>
      </div>
      <div class="md-layout-item">
        <md-field :class="getValidationClass('sensor')">
          <label :for="`sensor${_uid}`">Sensor</label>

          <md-select
            :id="`sensor${_uid}`"
            v-model="form.sensor"
            :name="`sensor${_uid}`"
            @md-selected="changeUpdate"
          >
            <md-option
              v-for="sensor in sensores"
              :key="sensor.id"
              :value="sensor.codigoIntegracao"
            >
              {{ sensor.descricao || sensor.codigoIntegracao }}
            </md-option>
          </md-select>
          <span v-if="!$v.form.sensor.required" class="md-error"
            >Sensor é requerido</span
          >
        </md-field>
      </div>

      <div class="md-layout-item md-size-20">
        <md-field :class="getValidationClass('comparador')">
          <label :for="`comparador${_uid}`">Comparador</label>
          <md-select
            :id="`comparador${_uid}`"
            v-model="form.comparador"
            :name="`comparador${_uid}`"
            @md-selected="changeUpdate"
          >
            <md-option value=">"> &gt; </md-option>
            <md-option value="<"> &lt; </md-option>
          </md-select>
          <span v-if="!$v.form.comparador.required" class="md-error"
            >Comparador é obrigatório</span
          >
        </md-field>
      </div>

      <div class="md-layout-item">
        <md-field :class="getValidationClass('valor')">
          <label :for="`valor${_uid}`">Valor</label>
          <md-input
            :id="`valor${_uid}`"
            v-model.number="form.valor"
            :name="`valor${_uid}`"
            type="number"
            step="0.00001"
            :disabled="sending"
            @change="changeUpdate"
          />
          <span v-if="!$v.form.valor.required" class="md-error"
            >Campo é obrigatório</span
          >
          <span v-else-if="!$v.form.valor.minMax" class="md-error"
            >Deve estar entre 0 e 9999</span
          >
        </md-field>
      </div>

      <div v-if="!newForm" class="md-layout-item">
        <md-button
          class="md-icon-button mt-3"
          @click="() => $emit('remove', { ...form })"
        >
          <md-icon>highlight_off</md-icon>
        </md-button>
      </div>
    </div>
  </form>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'MotoBombaExpressaoForm',
  mixins: [validationMixin],
  props: {
    newForm: {
      type: Boolean,
      default: false,
    },
    sensores: {
      type: Array,
      required: true,
    },
    expressao: {
      type: Object,
      default: () => ({
        sensor: null,
        comparador: '<',
        valor: 0,
      }),
    },
  },
  data: () => ({
    form: {
      sensor: null,
      valor: 0,
      comparador: '<',
    },
    sending: false,
  }),
  validations: {
    form: {
      sensor: {
        required,
      },
      comparador: {},
      valor: { required, minMax: (value) => value >= 0 && value <= 9999 },
    },
  },
  beforeMount() {
    this.form = { ...this.expressao }
  },
  methods: {
    changeUpdate() {
      if (this.newForm) {
        return
      }

      this.$v.$touch()

      if (this.$v.form.$invalid) {
        return
      }

      this.$emit('update', { ...this.form })
    },
    handleForm() {
      this.$v.$touch()

      if (this.$v.form.$invalid) {
        return
      }

      this.$emit('change', { ...this.form })
    },
    submitForm() {
      this.$refs.form.requestSubmit()

      if (this.$v.form.$invalid) {
        return null
      }

      return { ...this.form }
    },
  },
}
</script>
